import { render, staticRenderFns } from "./KBFiles.vue?vue&type=template&id=1f74585e&scoped=true"
import script from "./KBFiles.vue?vue&type=script&lang=js"
export * from "./KBFiles.vue?vue&type=script&lang=js"
import style0 from "./KBFiles.vue?vue&type=style&index=0&id=1f74585e&prod&lang=scss"
import style1 from "./KBFiles.vue?vue&type=style&index=1&id=1f74585e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f74585e",
  null
  
)

export default component.exports